"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exponentialBackoffDecorator;

var _q = require("q");

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDelayInMs(failureCount) {
  if (failureCount === 0) return 0;
  if (failureCount === 1) return 100;

  return getDelayInMs(failureCount - 1) * 2;
}

function exponentialBackoffDecorator(resolver) {
  var failureCount = 0;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var promise = _q2.default.promise(function (resolve) {
      setTimeout(function () {
        return resolve(resolver.apply(undefined, args));
      }, getDelayInMs(failureCount));
    });

    promise.then(function () {
      return failureCount = 0;
    }, function () {
      return failureCount++;
    });

    return promise;
  };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/decorators/exponentialBackoffDecorator.js
// module id = 457
// module chunks = 0